/**
 * Simple translation hook for React components
 * Uses the existing i18n system
 */

import { useSelector } from 'react-redux';
import { RootState } from '@/app/store';
import { translate } from '@/app/utils/i18nHelper';

export function useTranslation(): { t: (key: string, params?: Record<string, any>) => string; currentLanguage: string } {
  const currentLanguage = useSelector((state: RootState) => state.language?.currentLanguage || 'en-US');

  const t = (key: string, params?: Record<string, any>): string => {
    return translate(key, params);
  };

  return { t, currentLanguage };
}